import { ForgotPasswordContent } from "src/pages/ForgotPassword/ForgotPasswordContent"

export function OauthAuthorizeForgotPassword() {
  return (
    <ForgotPasswordContent
      backRoute="/oauth/authorize"
      doneRoute="/oauth/authorize"
    />
  )
}
